import React from 'react'
import {isFunction} from 'lodash'
import useSWR from 'swr'
import LoadingIndicator from '../component/shared/loading-indicator'
import ErrorBoundary from '../component/shared/error-boundary'
import Error from '../component/shared/error'

const withSWR = (Component, params) => {
  return (props) => {
    const {handleError} = props
    if (isFunction(params)) {
      params = params(props)
    }
    let {
      key,
      fetcher,
      defaultData = {},
      mutateFuncKey = 'mutate',
      displayLoading = true,
      options = {},
      onLoadingProps = {},
      onLoadedProps = {}
    } = params
    if (isFunction(key)) {
      key = key({...params, ...props})
    }
    const {loadingDisplay = () => <LoadingIndicator {...params}/>} = params
    let {data, error, mutate} = useSWR(key, fetcher, options)
    if (handleError) {
      mutate = handleError(mutate)
    }
    props = {...(data || defaultData || {}), ...props, [mutateFuncKey]: mutate}
    if (!!data) {
      props = {...props, ...onLoadedProps}
    } else {
      props = {...props, ...onLoadingProps}
    }
    if (error && !error.isSilent) {
      return (<Error error={error}/>)
    }
    if(!data && !props.parentLoading && displayLoading) {
      return loadingDisplay()
    }
    return (
      <ErrorBoundary error={error}>
        {/*{!data && !props.parentLoading && displayLoading && loadingDisplay()}*/}
        <Component {...{...props, parentLoading: !data}}/>
      </ErrorBoundary>
    )
  }
}

export {withSWR}

export default withSWR